<template>
  <div class="ql-container ql-snow">
    <!-- Page Content -->
    <div class="container">
      <div class="row">
        <div class="col-md-2"></div>
        <!-- Post Content Column -->
        <div class="col-md-8">
          <!-- Title -->
          <h1 class="mt-4">{{ title }}</h1>

          <!-- Author -->

          <hr />

          <!-- Date/Time -->
          <p>Publicado: {{ formatDate(created) }}</p>

          <hr />

          <!-- Preview Image -->
          <img v-if="feature_img !=null"
            class="img-fluid rounded"
            :src="feature_img"
            alt=""
          />

          <hr />
          <div class="ql-editor" style="max-width: 95% !important; height: auto;" v-html="content"></div>

          
        </div>
        <div class="col-md-2"></div>
        <!-- Sidebar Widgets Column -->
      </div>
      <!-- /.row -->
    </div>
    <!-- /.container -->
  </div>
</template>

<script>
/* eslint-disable */
import { mapState, mapActions } from "vuex";

import axios from "axios";
import moment from "moment";

import { quillEditor } from "vue-quill-editor";

document.querySelectorAll("pre.ql-syntax").forEach(block => {
  hljs.highlightBlock(block);
});

export default {
  name: "NoticeNew",
  components: {
    quillEditor,
    moment
    
  },
  data() {
    return {
      content: "<h1>Cargando ...</h1>",
      created: "",
      title: "",
      feature_img:"",
      editorOption: {},
      form: {
        body: "",
        id_category: null,
        id_creator: null
      },
      category_seleted: null,
      creators: [
        { value: null, text: "Seleccionar una opción" },
        { value: 1, text: "Creador 1" },
        { value: 2, text: "Creador 2" }
      ],
      categories: [],
      loading: false,
      error: ""
    };
  },
  mounted() {
    // Get the token directly from the route params
    const robustToken = this.$route.params.id;
    this.showNotice(robustToken);
  },
  methods: {
    ...mapActions(["getData"]),

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    showNotice(token) {
      let data_params = {
        url: "notice/preview/" + token,
      }
      this.getData(data_params)
        .then(response => {
          if (response.code === 200) {
            this.content = response.data.body;
            this.created = response.data.createdAt;
            this.title = response.data.title;
            this.feature_img = response.data.feature_img;

              setTimeout(
            function() {
              var images = document.getElementsByTagName("img")
              var i = 0
              for (i = 0; i < images.length;i++ ) {
                    images[i].style.maxWidth = "100%";
                }
              var videos = document.getElementsByTagName("iframe")
               for (i = 0; i < images.length;i++ ) {
                    videos[i].style.minWidth = "100%";
                    videos[i].style.minHeight = "300px";
                }
           // preview.style.width="100%";
            }, 1500);
          }
        })
        .catch(error => {
          console.error("error", error);
        });
    },
  
  }
};
</script>
<style scoped>
img {
  width: 100% !important;
}
.quill-editor iframe {
    pointer-events: none;
}
.ql-video {
  width: 90%
}
</style>